/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/

import { UntypedFormGroup, UntypedFormControl } from "@angular/forms";
import { AbstractObject } from "@src/app/model/abstract-object";
import { Field } from "@src/app/shared/field/Field";
import { GridControl } from "@src/app/shared/grid/grid-control";

export class GridRow extends UntypedFormGroup {
    focus: AbstractObject;
    fields: Field[];
    deleted = false;

    constructor(object, group, fields: Field[]) {
        super(group);
        this.focus = object;
        this.fields = fields;
    }

    getParent() {
        return this.parent as GridControl;
    }

    refreshFrom(o: AbstractObject) {
        //const chgs = [];
        this.focus = o;
        for (const f of this.fields) {
            f.setValue(o, f.readonly);
        }
    }

    getFormValue(getAll = false): AbstractObject {
        const newRow = {} as AbstractObject;
        this.fields.forEach(fld => {
            if (fld.sendServer || getAll) {
                newRow[fld.name] = fld.getFormValue();
            }
        });
        if (this.deleted) {
            newRow.deleted = true;
        }
        return newRow;
    }

    undelete() {
        if (this.deleted) {
            this.delete();
        }
    }

    delete() {
        if (!this.get('id') || this.get('id').value === null) {
            this.getParent().removeGridRow(this);
        } else {
            this.deleted = !this.deleted;
            this.markAsDirty();
            if (this.deleted) {
                this.addControl('deleted', new UntypedFormControl(true));
            } else {
                this.removeControl('deleted');
            }
        }
    }
}
